<template>
  <div>
    <report-view :url="downloadUrl">
      <strong>Van:</strong>
      <datepicker v-model="fromDate" :language="datepickerLang" format="dd-MM-yyyy" full-month-name />

      <strong>Tot en met:</strong>
      <datepicker v-model="untilDate" :language="datepickerLang" format="dd-MM-yyyy" full-month-name />
    </report-view>
  </div>
</template>

<script>
  import Api from '@/api';
  import { Events } from '@wsb/wsb-jsbase';
  import LoadOv from '@/components/LoadOverlay';
  import RV from '@/components/base/Reportview';
  import Datepicker from 'vuejs-datepicker';
  import { nl } from 'vuejs-datepicker/dist/locale';

  const _as = {
    name: 'ActiveSubstances',
    data() {
      return {
        fromDate: new Date((new Date() - 365 * 24 * 60 * 60 * 1000)),
        untilDate: new Date(),
        datepickerLang: nl
      };
    },
    created() {
    },
    computed: {
      downloadUrl() {
        return `/Report/ActiveSubstances?from=${this.fromDate.toISOString()}&until=${this.untilDate.toISOString()}`;
      }
    },
    components: {
      'report-view': RV,
      'load-overlay': LoadOv,
      Datepicker
    }
  };

  export default _as;
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/reports/ActiveSubstances.vue